<template>
  <div class="layout-no-nav">
    <slot />
  </div>
</template>

<script>
export default {
  name: "noNavbar"
};
</script>